import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SiteContext } from "../context/SiteContext";
import { api } from "../services/api";
import "./Noticias.css";

export default function Noticias() {
  const { config, loading } = useContext(SiteContext);
  const [noticias, setNoticias] = useState([]);
  const [loadingNoticias, setLoadingNoticias] = useState(true);

  // Estados dos Filtros
  const [filtroTitulo, setFiltroTitulo] = useState("");
  const [filtroAssunto, setFiltroAssunto] = useState("");
  const [filtroDataInicio, setFiltroDataInicio] = useState("");
  const [filtroDataFim, setFiltroDataFim] = useState("");

  useEffect(() => {
    async function fetchNoticias() {
      if (!config?.id) return;

      try {
        setLoadingNoticias(true);
        const response = await api.get(`/noticias/cliente/${config.id}`);
        setNoticias(response.data || []);
      } catch (error) {
        console.error("Erro ao buscar notícias:", error);
      } finally {
        setLoadingNoticias(false);
      }
    }

    fetchNoticias();
  }, [config]);

  const formatarData = (dataString) => {
    if (!dataString) return "";
    const data = new Date(dataString);
    return data.toLocaleDateString("pt-BR");
  };

  // Lógica de Filtragem
  const noticiasFiltradas = noticias.filter((noticia) => {
    // 1. Filtro por Título
    const matchTitulo = (noticia.titulo || "")
      .toLowerCase()
      .includes(filtroTitulo.toLowerCase());

    // 2. Filtro por Assunto/Categoria
    const assuntoNoticia = noticia.assunto || noticia.categoria || "";
    const matchAssunto = filtroAssunto === "" || assuntoNoticia === filtroAssunto;

    // 3. Filtro por Data
    let matchData = true;
    if (filtroDataInicio || filtroDataFim) {
      const noticiaData = new Date(noticia.createdAt || noticia.data);
      if (filtroDataInicio) {
        matchData = matchData && noticiaData >= new Date(filtroDataInicio);
      }
      if (filtroDataFim) {
        const dataFimAjustada = new Date(filtroDataFim);
        dataFimAjustada.setDate(dataFimAjustada.getDate() + 1);
        matchData = matchData && noticiaData <= dataFimAjustada;
      }
    }

    return matchTitulo && matchAssunto && matchData;
  });

  const limparFiltros = () => {
    setFiltroTitulo("");
    setFiltroAssunto("");
    setFiltroDataInicio("");
    setFiltroDataFim("");
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="hexagon-spinner"></div>
        <p className="loader-text">Carregando notícias...</p>
      </div>
    );
  }

  return (
    <div className="noticias-page">
      <div className="container noticias-container">
        {/* --- CAIXA DE FILTROS --- */}
        <div className="filters-box">
          <h2 className="filters-title">Notícias</h2>

          <div className="filters-grid">
            {/* Busca por Texto */}
            <div className="filter-group">
              <label>Título ou Palavra-chave</label>
              <input
                type="text"
                placeholder="Ex: Pagamento, Censo, Concurso..."
                value={filtroTitulo}
                onChange={(e) => setFiltroTitulo(e.target.value)}
              />
            </div>

            {/* Busca por Assunto/Categoria */}
            <div className="filter-group">
              <label>Assunto</label>
              <select
                value={filtroAssunto}
                onChange={(e) => setFiltroAssunto(e.target.value)}
              >
                <option value="">Todos os assuntos</option>
                <option value="Governança Corporativa">Governança Corporativa</option>
                <option value="Transparência">Transparência</option>
                <option value="Controles Internos">Controles Internos</option>
                <option value="Educação Previdenciária">Educação Previdenciária</option>
                <option value="Institucional">Institucional</option>
              </select>
            </div>

            {/* Busca por Data Inicial */}
            <div className="filter-group">
              <label>Data Inicial</label>
              <input
                type="date"
                value={filtroDataInicio}
                onChange={(e) => setFiltroDataInicio(e.target.value)}
              />
            </div>

            {/* Busca por Data Final */}
            <div className="filter-group">
              <label>Data Final</label>
              <input
                type="date"
                value={filtroDataFim}
                onChange={(e) => setFiltroDataFim(e.target.value)}
              />
            </div>
          </div>

          <div className="filters-actions">
            <button className="btn-clear-filters" onClick={limparFiltros}>
              Limpar Filtros
            </button>
          </div>
        </div>

        {/* --- LISTAGEM --- */}
        {loadingNoticias ? (
          <div className="loader-container">
            <div className="hexagon-spinner"></div>
            <p className="loader-text">Buscando notícias...</p>
          </div>
        ) : noticiasFiltradas.length === 0 ? (
          <div className="empty-search">
            Nenhuma notícia encontrada com esses filtros.
          </div>
        ) : (
          <div className="noticias-grid-page">
            {noticiasFiltradas.map((noticia) => (
              <div key={noticia.id} className="noticia-card-page">
                <div
                  className="noticia-img-page"
                  style={{
                    backgroundImage: `url(${noticia.imagem || "/assets/placeholder-news.jpg"})`,
                  }}
                >
                  {!noticia.imagem && <span className="no-img-text">Sem Imagem</span>}
                </div>

                <div className="noticia-body-page">
                  <span className="noticia-date-page">
                    {noticia.data || formatarData(noticia.createdAt)}
                  </span>
                  <h3 className="noticia-title-page">{noticia.titulo}</h3>
                  <p className="noticia-desc-page">
                    {noticia.resumo
                      ? noticia.resumo.substring(0, 100) + "..."
                      : "Sem descrição disponível."}
                  </p>

                  {/* Rota limpa para a notícia individual */}
                  <Link to={`/noticia/${noticia.id}`} className="btn-read-more">
                    Ler Mais ➔
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}